export default {
    modalQuickActionVariations: {
        title: 'Künstliche Intelligenz',
        generateWithAi: 'Generieren mit KI',
        improveWriting: 'Verbessere das Schreiben',
        fixSpelling: 'Korrigiere Rechtschreib- und Grammatikfehler',
        simplifyWriting: 'Vereinfachen Sie das Schreiben',
        makeLonger: 'Verlängern',
        makeShorter: 'Kürzen',
        replaceText: 'Ersetze Text',
        addBelow: 'Fügen Sie unten hinzu',
        cancel: 'Abbrechen',
        selectQuickActionTitle: 'Sagen Sie KI, was als Nächstes zu tun ist...',
        regenerate: 'Regenerieren',
    },
};
